import { Component } from '@angular/core';

@Component({
  selector: 'sens-icons',
  templateUrl: './icons.component.html',
  standalone: true,
})
export class IconsComponent {}
